module.exports = __webpack_public_path__ + "img/cupcake-3.eaf6e025.svg";